import React, { useState, useEffect } from "react";
import {
  Box,
  makeStyles,
  Typography,
  Button,
  Grid,
  LinearProgress,
} from "@material-ui/core";
import TokenPool from "../components/SearchTokenPools/TokenPool";
import ProjectDetailsModal from "../components/Modals/ProjectDetailsModal";
import { getCampaigns } from "../redux/actions/web3Actions";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  StepContainer: {
    background: "#FFFFFF",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",

    padding: "3rem",

    display: "flex",

    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: "3rem",
  },

  container: {
    padding: "3rem",
  },
}));

const SearchTokenPools = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const allCampaignData = useSelector((state) => state.ui.allCampaignData);
  const isUser = useSelector((state) => state.ui.isUser);

  console.log("allCampaignData ===> ", allCampaignData);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState();

  useEffect(() => {
    if (isUser) dispatch(getCampaigns(isUser.kol._id));
  }, [isUser]);
  return (
    <>
      <Box className={classes.container}>
        <Typography className={classes.pageHeading}>
          Active Token Pools
        </Typography>

        <Grid container>
          <Grid item>
            <Box className={classes.StepContainer}>
              {allCampaignData.map((data) => {
                return (
                  <TokenPool
                    data={data}
                    onClick={() => {
                      setModalData(data);
                      setShowModal(true);
                    }}
                  />
                );
              })}
            </Box>
          </Grid>
        </Grid>
      </Box>
      {modalData && (
        <ProjectDetailsModal
          showModal={showModal}
          setShowModal={setShowModal}
          modalData={modalData}
        />
      )}
    </>
  );
};

export default SearchTokenPools;
